<template>
    <div :class="index > 0 ? 'border-t border-gray-200 md:border-0 md:border-l': ''">
        <div class="px-4 py-5 sm:p-6">
            <dl>
                <dt class="text-base leading-6 font-normal text-gray-900">
                    {{ title }}
                </dt>
                <dd class="mt-1 flex justify-between items-baseline md:block lg:flex">
                    <div class="flex items-baseline text-2xl leading-8 font-semibold text-indigo-600">
                        {{ data.value }}
                        <span class="ml-2 text-sm leading-5 font-medium text-gray-500">from {{ data.previous }}</span>
                    </div>
                    <div v-if="growthPercentage" class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium leading-5 md:mt-2 lg:mt-0" :class="increaseOrDecreaseLabel === 'Decrease' ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'">
                        <svg v-if="increaseOrDecreaseLabel === 'Increase'" class="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                        </svg>
                        <svg v-if="increaseOrDecreaseLabel === 'Decrease'" class="-ml-1 mr-0.5 flex-shrink-0 self-center h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd" d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                        </svg>
                        <span class="sr-only">{{ increaseOrDecreaseLabel }}</span>
                        {{ growthPercentage }}%
                    </div>
                </dd>
            </dl>
        </div>
    </div>
</template>

<script>
    export default {
        name: "StatsCard",
        props: {
            title: {
                type: String,
                required: true
            },
            data: Object,
            index: Number
        },
        computed: {
            growthPercentage() {
                return Math.abs(this.increaseOrDecrease)
            },

            increaseOrDecrease() {
                if (this.data.previous === 0 || this.data.previous === null || this.data.value === 0)
                    return 0;

                return (((this.data.value - this.data.previous) / this.data.previous) * 100).toFixed(2)
            },

            increaseOrDecreaseLabel() {
                switch (Math.sign(this.increaseOrDecrease)) {
                    case 1:
                        return 'Increase';
                    case 0:
                        return 'Constant';
                    case -1:
                        return 'Decrease';
                }
            },

            sign() {
                switch (Math.sign(this.increaseOrDecrease)) {
                    case 1:
                        return '+';
                    case 0:
                        return '';
                    case -1:
                        return '-';
                }
            },

            isNullValue() {
                return this.data.value == null
            }
        },
    }
</script>
